import {gql} from '@apollo/client';

/**
 * POD 重传走 handleDspDeliveredEvent —— 与 DSP 原生端改 POD（DspParticularsPodPage）同一接口，
 * 保证 PC 端与 DSP App 行为一致：审核记录来源记为 DSP_UPDATE、鉴权要求 DSP 角色
 * （接口内部取 dspManagerRoleData，非 DSP 角色调用直接鉴权失败）。
 *
 * 本页 POD tab 仅 DSP 视角可见（IssueParcelWorkbenchPage 的 CATEGORY_DEFS 限定 modes: ['DSP']），
 * 调用方只会是 DSP_MANAGER / DSP_OWNER_TEAM，两者均持有 dspManagerRoleData。
 *
 * 对已妥投订单再次调用时，后端走 POD 重传专属分支：仅触发 OrderEventDataPodModified，
 * 不重复签收/结算/轨迹，不覆盖原 deliveredAt，location 不参与该分支。
 *
 * 返回值只取确认成功所需的最小字段（trackingNumber），不拉整套 DeliveryTaskOrder fragment。
 */
export const HANDLE_DSP_DELIVERED_EVENT = gql`
    mutation HandleDspDeliveredEvent($input: DeliveredEventInput!) {
        result: handleDspDeliveredEvent(input: $input) {
            id
            trackingNumber
        }
    }
`;

export interface HandleDspDeliveredEventInput {
    trackingNumber: string;
    location: {
        latitude: number;
        longitude: number;
    };
    deliveredAt: string;
    /** 重传的 POD 图片 objectKey 列表，1~6 张 */
    podImageS3KeysJson: string[];
    /** deliveryTaskOrderId */
    id: number;
}

export interface HandleDspDeliveredEventResponse {
    result: {
        id: number;
        trackingNumber: string;
    } | null;
}

/**
 * 构造 PC 端 DSP 经理「仅重传 POD」的入参，字段与 DSP 原生端 DspParticularsPodPage 保持一致：
 *  - location {0,0}：PC 端无 GPS；DSP 原生端取不到定位时同样传 0.0。已妥投订单走后端重传分支，
 *    location 不被消费、不落库。
 *  - deliveredAt now：与 DSP 原生端一致；重传分支不触发签收事件，不覆盖原 deliveredAt（仅为满足必填）。
 * podObjectKeys 张数限制（1~6）由调用方在提交前校验。
 */
export const buildPodReuploadInput = (
    trackingNumber: string,
    deliveryTaskOrderId: number,
    podObjectKeys: string[],
): HandleDspDeliveredEventInput => ({
    trackingNumber,
    location: {latitude: 0, longitude: 0},
    deliveredAt: new Date().toISOString(),
    podImageS3KeysJson: podObjectKeys,
    id: deliveryTaskOrderId,
});
